export { Alert, AlertSuccess, AlertWarning, AlertError, AlertInfo } from './Alert';
import GlobalPageAlert from './GlobalPageAlert';

export { GlobalPageAlert };
